export const getTwBgWithHoverActiveClass = (color: string) => {
  return `bg-${color} hover:bg-${color}/80 active:bg-${color}/40`
}

export const getTwHoverActiveClass = (color: string) => {
  return `hover:bg-${color}/10 active:bg-${color}/20`
}